import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import api from "@/lib/api";
import { LoadingState, ErrorState, EmptyState } from "@/components/shared/States";
import { PageHeader } from "@/components/shared/PageChrome";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function SupplierProperties() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => { api.get("/supplier/properties").then((r) => setData(r.data)).catch(() => setError(true)); }, []);

  if (error) return <ErrorState testId="supplier-properties-error" />;
  if (!data) return <LoadingState testId="supplier-properties-loading" />;

  const totalUnits = data.items.reduce((n, p) => n + p.units.length, 0);
  return (
    <div data-testid="supplier-properties-page" className="space-y-5">
      <PageHeader title="Your properties" subtitle="To add or change properties, submit an onboarding update - staff review before it goes live."
        chip={<span className="rounded-full border border-jigsaw-border px-2.5 py-0.5 text-[12px] text-jigsaw-muted">{data.items.length} {data.items.length === 1 ? "property" : "properties"} · {totalUnits} units</span>}
        actions={<Button asChild size="sm" variant="outline"><Link data-testid="supplier-properties-submit-link" to="/supplier/submissions">Submit a change</Link></Button>} />

      {data.items.length === 0 ? (
        <EmptyState testId="supplier-properties-empty" icon={Building2} title="No properties on file yet" description="Use Submissions to add your first property." />
      ) : (
        <Table data-testid="supplier-properties-table">
          <TableHeader><TableRow><TableHead>Property</TableHead><TableHead>Postcode &amp; locality</TableHead><TableHead>Units &amp; capacity</TableHead><TableHead>Current rate cards</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.items.map((p) => (
              <TableRow key={p.id} data-testid={`supplier-property-card-${p.id}`}>
                <TableCell><span className="flex items-center gap-3"><span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-jigsaw-bg text-jigsaw-muted"><Building2 className="h-4 w-4" /></span><span className="font-medium">{p.name}</span></span></TableCell>
                <TableCell><span className="font-mono-ref">{p.postcode || "—"}</span><span className="block text-[12px] text-jigsaw-muted">{p.city}</span></TableCell>
                <TableCell>{p.units.length === 0 ? <span className="text-jigsaw-muted">None recorded</span> : p.units.map((u) => <span key={u.id} className="block">{u.unit_type} <span className="text-jigsaw-muted">· capacity {u.capacity}</span></span>)}</TableCell>
                <TableCell>{p.rate_cards.length === 0 ? <span className="text-jigsaw-muted">None recorded</span> : p.rate_cards.map((r) => <span key={r.id} className="block"><span className="font-mono-ref">£{Number(r.rate_amount).toFixed(2)}</span> <span className="text-jigsaw-muted">from {r.effective_from}</span></span>)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
